import axios from "axios";


export const archiveThread = async (id, cancelToken) => {
    try {
        const { data } = await axios.get(`/api/feedback/archivefeedbackthread/${id}`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const archiveThreadParent = async (id, cancelToken) => {
    try {   
        const { data } = await axios.delete(`/api/feedback/archivefeedbackparent/${id}`, { cancelToken })  
        return data
    } catch (error) {
        throw error
    }
}; 



export const createFeedback = async (feedback,media) => {
    try {
        const fd = new FormData();
        fd.append('feedback', JSON.stringify(feedback));
       
        for (let i = 0; i < media.length; i++) {
            fd.append("files", media[i],media[i].name);
        }
        for (let pair of fd.entries()) {
            console.log(pair[0], pair[1]);
        }

        return axios({
       
            url: `/api/feedback/createfeedbackmessage`,
            method: "POST",
            data: fd,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            transformRequest: [(data) => data]
        })
          .then((response) => {
            return response;
          })
          .catch((error) => {
            throw error;
          });

        //const { data } = await axios.post(`/api/feedback/createfeedbackmessage`, fd)
        //return data
    } catch (error) {   
        throw error
    }
};

export const createThread = async (thread, cancelToken) => {
    try {
        const { data } = await axios.post(`/api/feedback/createfeedbackthread`, thread, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};    



export const deleteThread = async (thread_id, cancelToken) => {
    try {
        const { data } = await axios.post(`/api/feedback/deletefeedbackthread`,thread_id, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};  

export const deleteThreadParent = async (wip_id, cancelToken) => {
    try {
        const { data } = await axios.delete(`/api/feedback/deletefeedbackparent/${wip_id}`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
}; 


export const fetchAllFeedback = async (cancelToken) => {
    try {
        const { data } = await axios.get(`/api/feedback`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const fetchAllThreads = async (cancelToken) => {
    try {
        const { data } = await axios.get(`/api/feedback/allthreads`, { cancelToken })
        return data
    } catch (error) {
        throw error 
    }
};  

export const fetchThread = async (id, cancelToken) => {
    try {
        const { data } = await axios.get(`/api/feedback/getfeedbackthreads/${id}`, { cancelToken })
        return data
    } catch (error) {
        throw error     
    }
};

export const fetchWiAndUsers = async (id, cancelToken) => {
    try {   
        const { data } = await axios.get(`/api/feedback/wi-and-users/`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};  

export const fetchFeedback = (id) => {
    return axios.get(`/api/feedback/${id}`)
};

export const updateThreadUsers = async ( users, cancelToken) => {
    try {
        const { data } = await axios.post(`/api/feedback/updatethreadusers`, { users }, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};


